import { Stage } from "../config/config"
import common from "./sites/common"
import SafetyNonProd from "./sites/safety-nonprod"
import SafetyProd from "./sites/safety-prod"
import QualityNonProd from "./sites/quality-nonprod"
import QualityProd from "./sites/quality-prod"
import SustainabilityNonProd from "./sites/sustainability-nonprod"
import SustainabilityProd from "./sites/sustainability-prod"

const configMap = {
  "safety-community-hub": {
    dev: SafetyNonProd,
    test: SafetyNonProd,
    prod: SafetyProd
  },
  "quality-hub": {
    dev: QualityNonProd, //QualityNonProd,
    test: QualityNonProd,
    prod: QualityProd
  },
  "sustainability-hub": {
    dev: SustainabilityNonProd,
    test: SustainabilityNonProd,
    prod: SustainabilityProd
  }
}

const makeSiteConfig = (o, path) => {
  let libraryDrives = [{
    name: "Shared Documents",
    driveId: o.DOCUMENTS_DRIVE_ID,
    listId: o.DOCUMENTS_LIST_ID
  }]
  if (o.libraryDrives?.length) {
    const customDrives = []
    for (const d of o.libraryDrives) {
      customDrives.push({
        name: d.name,
        label: d.label,
        driveId: d.driveId,
        listId: d.listId,
        route: d.name.toLowerCase().replace(/ /g, '-')
      })
    }
    libraryDrives.push(...customDrives)
  }

  const basePath = window.location.origin;
  const unsubscribeLink = `${basePath}/${path}/unsubscribe`

  return {
    ...common,
    sitePath: path,
    unsubscribeLink,
    "label": o.LABEL,
    "siteId": o.SITE_ID,
    baseSitePath: `${common.baseSitePath}/${o.SITE}`,
    "urls": {
      "baseSite": `${common.domain}${common.baseSitePath}/${o.SITE}`
    },
    "listIds": {
      "pages": o.PAGES_LIST_ID,
      "documents": o.DOCUMENTS_LIST_ID,
      "documentLibrary": o.DOCUMENTS_LIST_ID
    },
    "driveIds": {
      "SiteAssets": o.SITE_ASSETS_DRIVE_ID,
      "documents": o.DOCUMENTS_DRIVE_ID,
      "Shared Documents": o.DOCUMENTS_DRIVE_ID,
    },
    libraryDrives,
    "templateIds": {
      "news": o.NEWS_TEMPLATE_ID
    },
    vivaCommunity: (o.VIVA_COMMUNITY_ID === undefined) ? null : {
      communityLinkPrefix: common.vivaCommunity.communityLinkPrefix,
      communityId: o.VIVA_COMMUNITY_ID
    },
    settingsFilePath: o.SETTINGS_FILE_PATH,
    optOutFilePath: o.OPT_OUT_FILE_PATH,
    managerRoles: o.MANAGER_ROLES
  }
}

export const getSiteConfig = (optSitePath) => {
  let sitePath = optSitePath
  if (!sitePath) {
    sitePath = window.location.hostname
    const paths = window.location.pathname.split('/')
    if (paths.length > 1) sitePath = paths[1]
  }
  const site = configMap[sitePath]

  if (!site || !site[Stage]) return {}
  return makeSiteConfig(site[Stage], sitePath)
}

export const getSiteConfigRoutes = () => {
  const configs = Object.keys(configMap).map(s => makeSiteConfig(configMap[s][Stage], s))
  return configs
}

export const getSiteConfigByItem = (sharepointItem) => {
  const configs = getSiteConfigRoutes()
  const target = configs.find(c => c.siteId === sharepointItem.parentReference.siteId)
  return target
}

export const getSiteConfigByDriveItem = (driveItem) => {
  const configs = getSiteConfigRoutes()
  const target = configs.find(c => {
    if (c.libraryDrives?.length) {
      return c.libraryDrives.some((d) => d.driveId === driveItem.parentReference.driveId)
    }
    return c.driveIds.documents === driveItem.parentReference.driveId
  })
  return target
}

export const getLibraryDriveFromConfig = (siteConfig, driveId=undefined, listId=undefined) => {
  const _default = siteConfig.libraryDrives[0]

  if (siteConfig.libraryDrives.length === 1) return _default
  
  const driveConfig = siteConfig.libraryDrives.find(d => d.driveId === driveId || d.listId === listId)
  return driveConfig ?? _default
}